import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectTranslations } from '../App/slice/selectors';
import { formatNumber, renderReplaceText } from 'utils/helper';

interface IComboInformationProps {
  dataInfo: any;
}
const ComboInformation: React.FC<IComboInformationProps> = props => {
  const { dataInfo } = props;
  const { tickets = [], combo = [], hotels = [] } = dataInfo?.orderItems || {};
  const ticket = tickets?.[0];
  const firstHotel = hotels?.[0];
  const translations = useSelector(selectTranslations);
  const numPassenger = useMemo(() => {
    return (
      +ticket?.quantity ||
      +(firstHotel?.adultQuantity || 0) + +(firstHotel?.childQuantity || 0) ||
      0
    );
  }, [ticket?.quantity, firstHotel?.adultQuantity, firstHotel?.childQuantity]);
  return (
    <Content>
      <SectionTitle>
        {renderReplaceText(translations?.['b2b.txt.comboHolidayPeople'], {
          combo: combo?.[0]?.comboName,
          n: numPassenger,
        })}
      </SectionTitle>
      <Row>
        <Label>{translations?.['b2b.txt.comboPricePerPerson']}</Label>
        <Value>{`${formatNumber(dataInfo?.paxPrice, '.')}đ`}</Value>
      </Row>
      <Row>
        <Label>{translations?.['b2b.txt.totalOrderValue']}</Label>
        <Value>{`${formatNumber(
          Number(dataInfo?.totalPriceHoliday) || 0,
          '.',
        )}đ`}</Value>
      </Row>
      <Row>
        <Label>
          {renderReplaceText(translations?.['b2b.txt.discountCommission'], {
            commission: String(dataInfo?.items?.[0]?.percentageCombo || 0),
          })}
        </Label>
        <Value>
          {dataInfo?.discountCombo > 0 && '-'}
          {`${formatNumber(dataInfo?.discountCombo, '.')}đ`}
        </Value>
      </Row>
      <Divider />
      <TotalRow>
        <TotalLabel>{translations?.['b2b.txt.totalPayment']}</TotalLabel>
        <TotalValue>{`${formatNumber(dataInfo?.totalPrice, '.')}đ`}</TotalValue>
      </TotalRow>
    </Content>
  );
};
export default ComboInformation;
const Content = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
`;
const SectionTitle = styled.div`
  background: #f2f2f2;
  padding: 8px 12px;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 12px;
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 0 12px;
  margin-top: 6px;
`;
const Label = styled.div`
  font-weight: 600;
`;
const Value = styled.div`
  font-weight: 600;
`;
const Divider = styled.div`
  height: 1px;
  background: #e5e5e5;
  margin: 12px 0;
`;
const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  padding-bottom: 12px;
`;
const TotalLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
const TotalValue = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
